import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getClientsList } from '../../../api/redux/slices/SuperAdmin';
import { companiesForAdmins } from '../../../api/redux/slices/SuperAdmin';
import { toast } from 'react-toastify';
import { LoaderComponent } from '../../../helpers/components/loader';
import Pagination from '../../../helpers/components/Pagination';
import { convertCategory, convertRegulation } from '../../../helpers/modules';

const ClientListPage = () => {
	const { list, total, allCompanies } = useSelector((state) => state.superAdmin);

	const [userName, setUserName] = useState('');

	const [selectedCompany, setSelectedCompany] = useState('');
	const [clientType, setClientType] = useState('');
	const [typing, setTyping] = useState(false);
	const [newArr, setNewArr] = useState([]);
	const params = useParams();
	const dispatch = useDispatch();
	const [page, setPage] = useState(Number(params.page));
	const token = localStorage.getItem('accesstoken');

	//------------------------- get companies for filter -------------------------------//
	useEffect(() => {
		if (token) {
			dispatch(companiesForAdmins({ token }));
		}
	}, [dispatch, token]);

	//------------------------- get list of all clients -------------------------------//
	const [isloading, setIsLoading] = useState(false);

	const stableDispatch = useCallback(() => {
		setIsLoading(true);
		dispatch(
			getClientsList({
				token: token,
				page: userName || selectedCompany || clientType ? 1 : page,
				search: userName,
				type: clientType || undefined,
				company: selectedCompany || undefined,
			}),
		)
			.unwrap()
			.then((res) => {
				const clientsList = res.data?.list || [];
				setNewArr(clientsList);
			})
			.catch((err) => {
				toast.error(err?.message || 'Erreur lors du chargement', {
					position: 'bottom-right',
					autoClose: 2000,
				});
				setNewArr([]);
			})
			.finally(() => setIsLoading(false));
	}, [dispatch, userName, selectedCompany, clientType, page, token]);

	useEffect(() => {
		if (token) {
			stableDispatch();
		}
	}, [stableDispatch, token]);

	// Mettre à jour la liste quand le store change
	useEffect(() => {
		if (list && list.length > 0) {
			setNewArr(list);
		}
	}, [list]);

	return (
		<div id='clientListPageAdmin'>
			<div className='navbar'>
				<div className='left'>
					<div className='nav-search'>
						<input
							type='text'
							placeholder='Rechercher par nom...'
							value={userName}
							onChange={(e) => {
								setUserName(e.target.value);
								setTyping(true);
							}}
						/>
						<icons.FiSearch className='searchicon' />
						{typing && (
							<icons.GrFormClose
								className='searchicon'
								onClick={() => {
									setUserName('');
									setTyping(false);
								}}
							/>
						)}
					</div>

					<div className='filters'>
						<select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
							<option value=''>Toutes les sociétés</option>
							{(allCompanies || []).map((company) => (
								<option key={company._id} value={company._id}>
									{company.name}
								</option>
							))}
						</select>
					</div>
					<div className='filters'>
						<select value={clientType} onChange={(e) => setClientType(e.target.value)}>
							<option value=''>Tous les clients</option>
							<option value='individual'>Clients individuels (sans société)</option>
							<option value='with_company'>Clients avec société</option>
						</select>
					</div>
				</div>
				<div className='right'>
					<div className='right-items'></div>
				</div>
			</div>
			<div id='head'>
				<div className='title-user'>
					<h1>Liste des clients</h1>
				</div>
			</div>
			<div className='usersContent'>
				<table id='users'>
					<thead>
						<tr id='titres'>
							<th>CLIENT</th>
							<th>SOCIÉTÉ</th>
							<th>MATRICULE FISCALE</th>
							<td style={{ margin: 'auto' }}>CATÉGORIE</td>
							<td style={{ margin: 'auto' }}>REGLEMENT</td>
							<td style={{ margin: 'auto' }}>TELEPHONE</td>
							<td style={{ margin: 'auto' }}>CODE DOUANE</td>
							<td style={{ margin: 'auto' }}>SPONSORSHIP</td>
						</tr>
					</thead>
					<tbody>
						{isloading ? (
							<tr>
								<td colSpan={8}>
									<LoaderComponent margin='10%' />
								</td>
							</tr>
						) : newArr.length > 0 ? (
							newArr.map((u, index) => (
								<tr id={`element-${index}`} className='user' key={u._id}>
									<td>
										{u.first_name} {u.last_name}
									</td>
									<td>{u.company_name ? u.company_name : '-'}</td>
									<td>{u.tax_registration_number ? u.tax_registration_number : '-'}</td>
									<td style={{ margin: 'auto' }}>
										{u.categories ? convertCategory(u.categories) : '-'}
									</td>
									<td style={{ margin: 'auto' }}>
										{u.regulation ? convertRegulation(u.regulation) : '-'}
									</td>
									<td>{u.phone ? u.phone : '-'}</td>
									<td style={{ margin: 'auto' }}>{u.customs_code ? u.customs_code : '-'}</td>
									<td style={{ margin: 'auto' }}>{u.company?.name ? u.company.name : '-'} </td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan={8} style={{ textAlign: 'center', padding: '50px' }}>
									Aucun client trouvé
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			<Pagination page={page} setPage={setPage} pageLink={`/superadmin/users/`} total={total} />
		</div>
	);
};

export default ClientListPage;
